import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  IonButton,
  IonIcon,
  IonImg,
  IonItem,
  IonList,
  IonText,
} from '@ionic/react';
import { starOutline } from 'ionicons/icons';
import { LOYALTY_JOIN, LOYALTY_REDEEM, LOYALTY_STAR } from 'pages/Loyalty';

function LoyaltyInfo({ venueDetail, programId, loyaltyPoints, setLoyaltyTypeModal, startScanNew }) {
  const onStarAction = useCallback(() => {
    if (loyaltyPoints) {
      setLoyaltyTypeModal(LOYALTY_STAR);
    } else {
      setLoyaltyTypeModal(LOYALTY_JOIN);
    }
  }, [loyaltyPoints]);

  const onRedeemAction = () => {
    setLoyaltyTypeModal(LOYALTY_REDEEM);
  };

  const loyaltyAvailablePoints = useMemo(() => {
    if (loyaltyPoints) {
      return loyaltyPoints.availablePoints.toFixed(2)
    }

    return 0;
  }, [loyaltyPoints]);

  const onBleScanAction = () => {
    startScanNew();
  }

  return (
    <IonList>
      <IonItem>
        <div className="d-flex-content d-flex-row align-center">
          <div className="d-flex-content">
            <div className="loyalty-coin-wrap">
              <IonText color="dark"><h2>{venueDetail?.name}</h2></IonText>

              {
                programId && (
                  <div className="loyal-icon-small-wrapper ml-1" onClick={onStarAction}>
                    <IonIcon
                      className="loyalty-icon-small"
                      icon={starOutline}
                      color="dark"
                    />
                  </div>
                )
              }
            </div>

            {
              loyaltyPoints && (
                <div className="d-flex-row mb">
                  <div className="loyalty-coin-wrap">
                    <IonText
                      className="text-bold"
                      color='tertiary'
                    >
                      {loyaltyAvailablePoints}&nbsp;
                    </IonText>

                    <IonImg src="/assets/vemos-coin.png" className="coin-img-icon" />

                    <IonText>&nbsp;available</IonText>
                  </div>

                  <IonButton
                    color="secondary"
                    expand="block"
                    fill="outline"
                    onClick={() => {
                      onRedeemAction();
                    }}
                    className="ml-2 loyalty-button-small-wrap"
                  >
                    <IonText color="dark" autoCapitalize="words">Redeem</IonText>
                  </IonButton>
                </div>
              )
            }
          </div>

          {
            venueDetail?.mobileCredentialEnabled
            && <IonImg src="/assets/ble-scan-icon.png" className="ble-scan-icon" onClick={onBleScanAction} />
          }


        </div>
      </IonItem>
    </IonList>
  );
}

LoyaltyInfo.propTypes = {
  venueDetail: PropTypes.object,
  loyaltyPoints: PropTypes.object,
  setLoyaltyTypeModal: PropTypes.func,
  programId: PropTypes.string,
  startScanNew: PropTypes.func,
};

export default LoyaltyInfo;
